import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom';

import DigitalLetterDraft from './DigitalLetterDraft';
import DigitalLetterComposeDraft from './DigitalLetterComposeDraft';

export default function DigitalLetterDraftMain() {
    const [showDraftList, setShowDraftList] = useState(true);
    const location = useLocation();

    const details = useMemo(() => {
      const searchParams = new URLSearchParams(location.search);
      const details = searchParams.get('details');

      return details;
    }, [location.search]);

    useEffect(() => {
      const shouldShowList = details !== 'true';
      setShowDraftList(shouldShowList);
    }, [details]);

    return showDraftList ? <DigitalLetterDraft/> : <DigitalLetterComposeDraft/>;
}
